import { Model, tProp, types } from "mobx-keystone";
import { PluginStatus } from "../../../../../core/enums";
import { pluginNS } from "./ns";

@pluginNS.model
export default class PluginDefModel extends Model({
  refId: tProp(types.string),
  title: tProp(types.string),
  description: tProp(types.string),
  resources: tProp(types.array(types.string)),
  status: tProp(types.maybeNull(types.enum(PluginStatus))),
  meta: tProp(types.unchecked<Record<string, unknown>>()),
}) {}
